import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {EventManager} from "shared/utilities/Events/EventManager";
import {GetControl} from "InternalShared/Events/GetControl";
import {IPDFContainer} from "InternalShared/PageBuilder/Controls/Core/IPDFContainer";

export class PDFControlGenerator{
    public static GetControl(Page:IPDFContainer, optionsOrType:PDFControlBaseOptions|string)
    {
        let controlType:string;
        let options:any=null;
        if(optionsOrType instanceof PDFControlBaseOptions)
        {
            controlType=optionsOrType.Type;
            options=optionsOrType;
        }else{
            controlType=optionsOrType;
        }

        let item=EventManager.Publish(new GetControl(controlType));
        if(item==null)
            throw new Error('Invalid control type: '+controlType);

        if(options!=null)
            item.Initialize(Page,options);
        return item;
    }
}